module.exports = __webpack_public_path__ + "img/back.18c454fb.svg";